var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width ml-0 mr-0 end-bottom-padding subpage-wrapper"},[_c('startseite',{staticClass:"full-width ml-0 mr-0"}),_c('aktuell',{staticClass:"col2"}),_c('archive-note',{staticClass:"col2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }